<template>
  <div style="margin: 10px; height: 250px">
    <v-form direction="horizontal">
      <div style="text-align: left">
        <v-affix :offset-top="10">
          <v-button type="success" icon="save" @click.prevent="save()"
            >保存</v-button
          >
        </v-affix>
      </div>
      <v-form-item
        label="考勤规则代码"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-input
          v-model="options.gzdm"
          placeholder="考勤规则代码"
          v-bind:disabled="gzdm_dis"
        ></v-input>
      </v-form-item>
      <v-form-item
        label="考勤规则名称"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-input v-model="options.gzmc" placeholder="考勤规则名称"></v-input>
      </v-form-item>
      <v-form-item
        label="当月考勤起始日"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-input v-model="options.kssj" placeholder="当月考勤起始日"></v-input>
      </v-form-item>
      <v-form-item
        label="次月考勤截止日"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-input v-model="options.jssj" placeholder="次月考勤截止日"></v-input>
      </v-form-item>
       <v-form-item
        label="延迟天数"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-input v-model="options.ycts" placeholder="延迟天数"></v-input>
      </v-form-item>
    </v-form>
  </div>
</template>

<script>
let options = {
  id:"",
  gzdm: "",
  gzmc: "",
  kssj: "",
  jssj: "",
  ycts: ""
};
export default {
  data() {
    return {
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
      options,
      gzdm_dis: false,
    };
  },
  created() {
    if (this.$route.query.id) {
      this.init();
      this.gzdm_dis = true;
    }else{
      this.options.ycts = 0;
    }
  },
  methods: {
    init: function () {
      this.$axios
        .get("api/system/kqgzwh/get-kqgz-first?id=" + this.$route.query.id)
        .then((res) => {
          this.options = res.data
        });
    },
    save() {
      if(!this.options.gzdm){
        this.$message["error"]("请输入考勤规则代码");
        return;
      }
      if(!this.options.gzmc){
        this.$message["error"]("请输入考勤规则名称");
        return;
      }
      if(!this.options.ycts){
        this.$message["error"]("请输入考勤延迟天数");
        return;
      }
      if (this.$route.query.id) {
        this.$axios
          .post("api/system/kqgzwh/update-kqgz-first", this.options)
          .then((res) => {
            if (res.data.code == 200) {
              this.$message["success"](res.data.message);
              xadmin.close();
              xadmin.father_reload();
            } else {
              this.$message["error"](res.data.message);
            }
          });
      } else {
        this.$axios
          .post("api/system/kqgzwh/set-kqgz-first", this.options)
          .then((res) => {
            if (res.data.code == 200) {
              this.$message["success"](res.data.message);
              xadmin.close();
              xadmin.father_reload();
            } else {
              this.$message["error"](res.data.message);
            }
          });
      }
    },
    cancel: function () {
      xadmin.close();
    },
  },
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/xtgl/jcsj/kqgzwhadd.vue